var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.downloadKey)?_c('img',{class:_vm.imgclass,attrs:{"src":_vm.srcWithKey}}):_c('div',{staticClass:"spinner-border text-dark",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])}
var staticRenderFns = []

export { render, staticRenderFns }